<template>
  <UninstallThankYou v-if="currentView === 'thankyou'"/>
  <UninstallRemoveCode v-else @continue="handleContinue"/>
</template>

<script>
import UninstallThankYou from "./UninstallThankYou.vue";
import UninstallRemoveCode from "./UninstallRemoveCode.vue";

export default {
  name: 'UninstallCodeManagement',
  components: {
    UninstallThankYou,
    UninstallRemoveCode
},
  data() {
    return {
      currentView: 'remove-code',
    }
  },
  methods: {
    handleContinue() {
      this.currentView = 'thankyou';
    }
  },
}
</script>
